import { mapActions, mapGetters } from "vuex";
import TransactionService from '@/store/services/transactions.service';
import SubscriptionService from "@/store/services/subscriptions.service";

export default {
  computed: {
    ...mapGetters({ 
      pageProps: "pagePropertiesStore/getPageProperties"
    })
  },
  created () {
    this.setPageProperties(this.pageSettings)
  },
  methods: {
    ...mapActions({ 
      setPageProperties: "pagePropertiesStore/setPageProperties"
    }),
    onSubscriptionLoaded(val) {
      this.subscription = JSON.parse(JSON.stringify(val));
    },
    onCycleChanged(val) {
        this.subscription.renewal_months = val;
    },
    save() {
        let vm = this;
        if (this.$store.getters['getIsPremium']) {
            SubscriptionService.update(this.subscription.id, this.subscription).then(function(){
                vm.$router.push({name: "Subscriptions"}).then(function() {
                    vm.$store.commit('setAlert', {
                        vm: vm,
                        title: vm.$gettext("Info"),
                        text: vm.$gettext("Subscription updated correctly"),
                        duration: 4
                    });
                });
            }).catch(function(error) {
                if (error.status === 403) {
                    vm.$store.commit('setAlert', {
                        vm: vm,
                        title: vm.$gettext("Error updating the subscription"),
                        text: vm.$gettext("You do not have permissions to update a subscription."),
                        variant: "error",
                        duration: 4
                    });
                } else if (error.status === 400) {
                    var firstDictKey = Object.keys(error.data)[0];
                    var msg = error.data[firstDictKey];
                    vm.$store.commit('setAlert', {
                        vm: vm,
                        title: vm.$gettext("Error updating the subscription"),
                        text: msg,
                        variant: "error",
                        duration: 4
                    });
                } else {
                    vm.$store.commit('setAlert', {
                        vm: vm,
                        title: vm.$gettext("Error updating the subscription"),
                        text: vm.$gettext("Something went wrong..."),
                        variant: "error",
                        duration: 4
                    });
                }

                vm.$router.push({name: "Subscriptions"});
            });
        } else { // if subscription is basic
            let params = {upgrade_to_premium: true};

            SubscriptionService.update(vm.subscription.id, vm.subscription).then(function(){
                vm._createTransaction(params);
            }).catch(function(error){
                if (error.status === 403) {
                    vm.$store.commit('setAlert', {
                        vm: vm,
                        title: vm.$gettext("Error updating the subscription"),
                        text: vm.$gettext("You do not have permissions to update a subscription."),
                        variant: "error",
                        duration: 4
                    });
                } else if (error.status === 400) {
                    var firstDictKey = Object.keys(error.data)[0];
                    var msg = error.data[firstDictKey];
                    vm.$store.commit('setAlert', {
                        vm: vm,
                        title: vm.$gettext("Error updating the subscription"),
                        text: msg,
                        variant: "error",
                        duration: 4
                    });
                } else {
                    vm.$store.commit('setAlert', {
                        vm: vm,
                        title: vm.$gettext("Error updating the subscription"),
                        text: vm.$gettext("Something went wrong..."),
                        variant: "error",
                        duration: 4
                    });
                }

                this.$router.push({name: "Subscriptions"});
            });
        }
    },
    _createTransaction(params) {
        let vm = this;
        TransactionService.create(params).then(function(response){
            vm.$router.push({name: "ConfirmPayment", params: {transactionId: response.data.id}});
        }).catch(function(error){
            if (error.status === 403) {
                vm.$store.commit('setAlert', {
                    vm: vm,
                    title: vm.$gettext("Error creating transaction"),
                    text: vm.$gettext("You do not have permissions to create a transaction."),
                    variant: "error",
                    duration: 4
                });
            } else if (error.status === 400) {
                var firstDictKey = Object.keys(error.data)[0];
                var msg = error.data[firstDictKey];
                vm.$store.commit('setAlert', {
                    vm: vm,
                    title: vm.$gettext("Error creating a transaction"),
                    text: msg,
                    variant: "error",
                    duration: 4
                });
            } else {
                vm.$store.commit('setAlert', {
                    vm: vm,
                    title: vm.$gettext("Error creating a transaction"),
                    text: vm.$gettext("Something went wrong..."),
                    variant: "error",
                    duration: 4
                });
            }
        });
    },
  }
}